import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { ReactTyped } from "react-typed";

export default function InputFunction() {
  const [showSection1, setShowSection1] = useState(false);
  const [labelOneInput, setLabelOneInput] = useState("");
  const [labelTwoInput, setLabelTwoInput] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [amount, setAmount] = useState(0);
  const [percentage, setPercentage] = useState(0);
  const [finalAmount, setFinalAmount] = useState();
  const [amountTwo, setAmountTwo] = useState(0);
  const [person, setPerson] = useState(0);
  const [eachPerson, setEachPerson] = useState();
  const [optionOneSubmitted, setOptionOneSubmitted] = useState(false); // State to track if Option 1 is submitted
  const [optionTwoSubmitted, setOptionTwoSubmitted] = useState(false); // State to track if Option 2 is submitted

  const handleRadioChange = (event) => {
    const value = event.target.value;
    setShowSection1(value === "yes");
    setOptionOneSubmitted(false); // Reset optionOneSubmitted when radio changes
    setOptionTwoSubmitted(false); // Reset optionTwoSubmitted when radio changes
  };

  const handleLabelOneChange = (event) => {
    setLabelOneInput(event.target.value);
  };

  const handleLabelTwoChange = (event) => {
    setLabelTwoInput(event.target.value);
  };

  const handleDropdownChange = (event) => {
    setSelectedOption(event.target.textContent.trim());
  };

  const handleAmountChange = (event) => {
    const value = parseFloat(event.target.value);
    setAmount(value);
    calculateFinalAmount(value, percentage);
  };

  const handlePercentageChange = (event) => {
    const value = parseFloat(event.target.value);
    setPercentage(value);
    calculateFinalAmount(amount, value);
  };

  const handleAmountTwoChange = (event) => {
    const value = parseFloat(event.target.value);
    setAmountTwo(value);
    calculateEachPerson(value, person);
  };

  const handlePersonChange = (event) => {
    const value = parseFloat(event.target.value);
    setPerson(value);
    calculateEachPerson(amountTwo, value);
  };

  const handleOptionOneSubmit = () => {
    setOptionOneSubmitted(true);
  };

  const handleOptionTwoSubmit = () => {
    setOptionTwoSubmitted(true);
  };

  const calculateFinalAmount = (amount, percentage) => {
    const jj = (percentage / 100) * amount;
    const final = amount - jj;
    setFinalAmount(final);
  };

  const calculateEachPerson = (amountTwo, person) => {
    if (person !== 0) {
      const each = amountTwo / person;
      setEachPerson(each);
    } else {
      setEachPerson(undefined);
    }
  };

  return (
    <div className="">
      <div className="fw-semibold text-center font_size_loan_investment_one  hieght_fixed">
        <ReactTyped
          strings={["Proportional Distribution Calculator"]}
          typeSpeed={30}
          loop={false}
          showCursor={false} // Hide the cursor
        />
      </div>

      <div className="container d-flex justify-content-between witdh_investment_one_mediaquery main_div  border_color">
        <div className="">Investment</div>
        <div className="d-flex">
          <input
            className="form-check-input"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault1"
            value="yes"
            onChange={handleRadioChange}
          />
          <div className="ms-3">Yes</div>
        </div>
        <div className="d-flex">
          <input
            className="form-check-input"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault2"
            value="no"
            onChange={handleRadioChange}
          />
          <div className="ms-3">No</div>
        </div>
      </div>

      {showSection1 && (
        <div className="section_one maring_stuf  container">
          <Card className="card_main border_color">
            <Card.Body>
              <div className="link">
                <div className="dropdown ">
                  <div className="d-flex justify-content-around align-items-center">
                    <div className="button_years_months">
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={handleDropdownChange}
                      >
                        Option-1
                      </a>
                    </div>
                    <div className="button_years_months">
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={handleDropdownChange}
                      >
                        Option-2
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      )}

      {/* Option 1 */}
      {selectedOption === "Option-1" && (
        <>
          <div className="section_one maring_stuf  container">
            <Card className="card_main border_color">
              <Card.Body>
                <div className=" text-center fs-5 mb-4"> Distribution between 2 people</div>
                <hr className="mx-auto w-50 bg-success"/>
                <div className="label_1 text-start">
                  <div className="fs-5 mb-3 ">Name - 1 </div>
                  <div className="input-group mb-3 input_Box">
                    <input
                      required="required"
                      type="text"
                      className=""
                      placeholder="Enter Name"
                      value={labelOneInput}
                      onChange={handleLabelOneChange}
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                    />

                    <i></i>
                  </div>
                </div>
                <div className="label_1 text-start ">
                  <div className="fs-5 mb-3 ms-1">Name - 2 </div>
                  <div className="input-group mb-3 input_Box">
                    <input
                      required="required"
                      type="text"
                      className=""
                      placeholder="Enter Name"
                      value={labelTwoInput}
                      onChange={handleLabelTwoChange}
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                    />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>

          <div className="option_one maring_stuf container">
            <Card className="card_main">
              <Card.Body>
                <div className="Amount text-start">
                  <div className="fs-5 mb-3 ms-1">Amount</div>
                  <div className="input-group mb-3 ">
                    <span className="input-group-text btn_primary drop_button_small">
                      $
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      aria-label="Amount (to the nearest dollar)"
                      onChange={handleAmountChange}
                    />
                  </div>
                </div>
                <div className="Percetange text-start">
                  <div className="fs-5 mb-3 ms-1">Percentage</div>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter in Number"
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                      onChange={handlePercentageChange}
                    />
                    <span
                      className="input-group-text btn_primary drop_button_small"
                      id="basic-addon2"
                    >
                      %
                    </span>
                  </div>
                </div>
                <div className="Final Amount text-start">
                  <div className="fs-5 mb-3 ms-1">Final Amount</div>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Final Amount"
                      value={`${finalAmount} $`}
                      readOnly
                    />
                  </div>
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn_primary drop_button"
                    onClick={handleOptionOneSubmit} // Call handleOptionOneSubmit when submit button is clicked
                  >
                    Submit
                  </button>
                </div>
              </Card.Body>
            </Card>
          </div>
        </>
      )}

      {/* Option 2 */}
      {selectedOption === "Option-2" && (
        <div className="option_two maring_stuf container ">
          <Card className="card_main">
            <Card.Body>
              <div className="text-center  fs-5 ">Distribution between many people</div>
              <hr className="mx-auto w-50 bg-success"/>
              <div className="Amount_option_two text-start">
                <div className="fs-5 mb-3 ms-1">Amount</div>
                <div className="input-group mb-3">
                  <span className="input-group-text btn_primary  drop_button_small">
                    $
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Amount (to the nearest dollar)"
                    onChange={handleAmountTwoChange}
                  />
                </div>
              </div>
              <div className="Person_option_two text-start">
                <div className="fs-5 mb-3 ms-1">Person</div>
                <div className="input-group mb-3">
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Amount (to the nearest dollar)"
                    onChange={handlePersonChange}
                  />
                </div>
              </div>
              <div className="Each_Person_option_two text-start">
                <div className="fs-5 mb-3 ms-1">Each Person</div>
                <div className="input-group mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Each Person"
                    value={eachPerson}
                    readOnly
                  />
                </div>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn_primary"
                  onClick={handleOptionTwoSubmit} // Call handleOptionTwoSubmit when submit button is clicked
                >
                  Submit
                </button>
              </div>
            </Card.Body>
          </Card>
        </div>
      )}

      {/* Option-1-submit */}
      {optionOneSubmitted && (
        <div className="option_one_submit maring_stuf container">
          <Card className="card_main">
            <Card.Body>
            <div className="text-center  fs-5 ">Final Result - 1</div>
            <hr className="mx-auto w-50 bg-success"/>
              <div className="d-flex justify-content-between mt-3">
                <div className="">
                  <div className="fs-5 text-start">Amount</div>
                  <div className="Amount w-75">
                    {" "}
                    <div class="input-group mb-3">
                      <span className="input-group-text btn_primary drop_button_small">
                        $
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Each Person"
                        value={amount}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className=" text-start">
                  <div className="fs-5 ">Percentage</div>
                  <div className="percentage">
                    <div class="input-group w-75">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Each Person"
                        value={percentage}
                        readOnly
                      />
                      <span
                        class="input-group-text drop_button_small btn_primary "
                        id="basic-addon2"
                      >
                        %
                      </span>
                    </div>
                  </div>
                </div>
                <div className=" text-start">
                  <div className="fs-5 ">Final Amount</div>
                  <div className="final_amount w-75 ">
                    {" "}
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Each Person"
                      value={`${finalAmount} $`}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between">
                <div className="text-start">
                  <div className="fs-5  pb-2">{labelOneInput} will get </div>
                  <div className="label_1_value">
                    {" "}
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Each Person"
                      value={`${finalAmount / 2} $`}
                      readOnly
                    />
                  </div>
                </div>
                <div className="text-start">
                  <div className="fs-5 pb-2">{labelTwoInput} will get </div>
                  <div className="label_2_value">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Each Person"
                      value={`${finalAmount / 2} $`}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      )}

      {/* Option-2-submit */}
      {optionTwoSubmitted && (
        <div className="option_two_submit maring_stuf container">
          <Card className="card_main">
            <Card.Body>
            <div className="text-center  fs-5 ">Final Result - 2</div>
            <hr className="mx-auto w-50 bg-success"/>
              <div className="d-flex justify-content-between">
                <div className="text-start">
                  <div className="fs-5  pb-2">Amount</div>
                  <div className="amount_value">
                    {" "}
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Amount"
                      value={amountTwo}
                      readOnly
                    />
                  </div>
                </div>
                <div className="text-start">
                  <div className="fs-5 pb-2">Person</div>
                  <div className="person_value">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Person"
                      value={person}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between mt-3">
                <div className="">
                  <div className="fs-5 text-start">Each Person</div>
                  <div className="each_person w-75">
                    {" "}
                    <div class="input-group mb-3">
                      <span className="input-group-text btn_primary  drop_button_small">
                        $
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Each Person"
                        value={eachPerson}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      )}
    </div>
  );
}
